import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Notification, Typography } from '@telus-uds/components-web';

import request from '../../../../utils/request';
import {
  AddContainer,
  AddingMain,
  AddActions,
  AddInput
} from '../css';

const Add = ({ fetchData }) => {
  const [domainName, setDomainName] = useState(null);
  const [addingMode, setAddingMode] = useState(false);
  const [validationError, setValidationError] = useState(false);

  const addDealership = async () => {
    try {
      if (!domainName) {
        setValidationError(true);
        return;
      }

      const result = await request.post(`/domains`, {
        name: domainName
      });

      if (result && result.status === 200) {
        setDomainName('');
        setAddingMode(false);
        fetchData();
      }
    } catch (err) {
      setDomainName('');
      setAddingMode(false);
      throw err;
    }
  };

  return (
    <AddContainer>
      {!addingMode && (
        <Button variant={{ priority: 'low' }} onPress={() => setAddingMode(true)}>
          Add Domain
        </Button>
      )}
      {addingMode && (
        <AddingMain>
          <Typography heading="h3" variant={{ size: 'h3' }} block>Add Domain</Typography>
          <AddActions>
            <AddInput
              type="text"
              placeholder="domain name..."
              value={domainName}
              onChange={({ target: { value } }) => setDomainName(value)}
            />
            <Button type="button" variant={{ priority: 'high' }} onPress={addDealership}>
              Add
            </Button>
            <Button
              variant={{ priority: 'low' }}
              type="button"
              onPress={() => setAddingMode(false)}
            >
              Cancel
            </Button>
          </AddActions>
          <p>
            <strong>Note:</strong> Please write proper domain consisting of
            domain name and suffix (e.g. telus.com)
          </p>
          {validationError && (
            <Notification
              variant={{ validation: 'error' }}
              dismissible
              onExit={() => setValidationError(false)}
              copy="en"
            >
              Please make sure the domain name is not empty
            </Notification>
          )}
        </AddingMain>
      )}
    </AddContainer>
  );
};

Add.propTypes = {
  fetchData: PropTypes.func.isRequired
};

export default Add;
